import { packagesGift } from 'assets/images';
import { Button } from 'components/UI/Button/Button';
import React from 'react';
import classes from './PurchaseBanner.module.scss';

interface PurchaseBannerProps {
    onPurchase: () => void;
}

export const PurchaseBanner: React.FC<PurchaseBannerProps> = ({ onPurchase }) => {
    return (
        <div className={classes.root}>
            <img src={packagesGift} alt="" className={classes.image} />

            <div className={classes.content}>
                <p className={classes.title}>Purchase Packages &amp; Memberships</p>

                <p className={classes.description}>
                    Explore our selected packages and memberships to find the perfect option for
                    your needs.
                </p>

                <Button
                    size="medium"
                    variant="black"
                    className={classes.button}
                    onClick={onPurchase}
                >
                    Purchase
                </Button>
            </div>
        </div>
    );
};
